import { useQuery, UseQueryResult } from '@tanstack/react-query';
import { API_ENDPOINTS } from '@api/ApiEndpoints';
import { useHttpClient } from '@hooks/utils/httpConfig';
import { EnhancedRoadmapDto } from '@cloudclevr/components';

export function useOrganizationRoadmaps(p0: { enabled: boolean; }): UseQueryResult<EnhancedRoadmapDto[]> {
  const client = useHttpClient();

  const fetchRoadmaps = async (): Promise<EnhancedRoadmapDto[]> => {
    if (!p0.enabled) {
      return [];
    }

    try {
      const response = await client.get<EnhancedRoadmapDto[]>(
      API_ENDPOINTS.ROADMAPS_ALL("Categories.SubCategories")
      );
      return response;
    } catch (error) {
      console.error('Error fetching organization roadmaps:', error);
      throw error;
    }
  };

  return useQuery<EnhancedRoadmapDto[], Error>({ queryKey: ['organizationRoadmaps', p0.enabled], queryFn: fetchRoadmaps, 
      refetchOnWindowFocus: false,
      gcTime: 5000,
      staleTime: 5000,
    }
  );
}